export const Mutations = {
  INSERT_DEAL_ITEMS: 'INSERT_DEAL_ITEMS',
  REMOVE_DEAL_ITEMS: 'REMOVE_DEAL_ITEMS',
}
